import { Button } from 'antd';
import { AntModal } from '../../../components';
import { ChevronRightIcon } from '../../../components/assets';
import { useNavigate } from 'react-router-dom';

type RemoveLocationsModalProps = {
  isOpen: boolean;
  onCancel: () => void;
  onRemove: () => void;
  locations: {
    name: string;
    url?: string;
  }[];
  extendActions?: JSX.Element | null;
};

export const RemoveLocationsModal = ({
  isOpen,
  onCancel,
  onRemove,
  locations,
  extendActions,
}: RemoveLocationsModalProps) => {
  const navigate = useNavigate();

  return (
    <AntModal
      openModal={isOpen}
      onCancel={onCancel}
      title="Remove Locations"
      footer={[
        <div key="footer" className="m-4 flex justify-between gap-4">
          <Button key="cancel" onClick={onCancel} shape="round">
            Cancel
          </Button>
          <Button
            key="remove"
            type="primary"
            danger
            onClick={onRemove}
            shape="round"
          >
            Remove Locations
          </Button>
        </div>,
      ]}
    >
      <div className="flex flex-col gap-3">
        <div className='flex flex-col gap-4 border-b border-gray-200 pb-2'>
         <p>You are about to remove a Location that has dependencies already mapped to it.</p>
          <div className="flex justify-between">
            <p>Location to remove:</p>
            {extendActions && extendActions}
          </div>
        </div>
        <div className='flex flex-col gap-3'>
          {locations.map((location, index) => (
            <div
              key={index}
              className="flex items-center justify-between border-b border-gray-200 pb-2"
            >
              <span className="text-left font-semibold">{location.name}</span>
              {location.url &&
                <Button
                type="link"
                size="small"
                onClick={() =>
                  location?.url ? navigate(location.url) : null
                }
                className="group flex items-center p-0 h-auto"
              >
                <div className="flex items-center gap-4">
                  View Location
                  <ChevronRightIcon width={8} height={14} className="group-hover:opacity-50 hover:!fill-[#437EF7]" />
                </div>
              </Button>
              }
            </div>
          ))}
        </div>

        <p className="font-semibold">
          This action will permanently delete all dependencies associated to it.  
          <br />
          Are you sure you want to do that?
        </p>
      </div>
    </AntModal>
  );
};
